import {
    AddDriverTrackingCommand,
    AddDriverTrackingResponse,
    RegisterDriverCommand,
    RegisterDriverResponse,
    SendConsignmentStatusCommand,
    SendConsignmentStatusResponse,
    ReportParcelCountDiscrepancyCommand,
    ReportParcelCountDiscrepancyResponse
} from "@core/services/api.service";

// Add Driver Tracking
export class AddDriverTrackingAction {
    static readonly type = '[Driver Tracking] Add Driver Tracking';

    constructor(public command: AddDriverTrackingCommand) { }
}

export class AddDriverTrackingSuccessAction {
    static readonly type = '[Driver Tracking] Add Driver Tracking Success';

    constructor(public payload: { response: AddDriverTrackingResponse }) { }
}

export class AddDriverTrackingFailAction {
    static readonly type = '[Driver Tracking] Add Driver Tracking Fail';

    constructor(public error?: any) { }
}

// Register Driver
export class RegisterDriverAction {
    static readonly type = '[Driver Tracking] Register Driver';

    constructor(public command: RegisterDriverCommand) { }
}

export class RegisterDriverSuccessAction {
    static readonly type = '[Driver Tracking] Register Driver Success';

    constructor(public payload: { response: RegisterDriverResponse }) { }
}

export class RegisterDriverFailAction {
    static readonly type = '[Driver Tracking] Register Driver Fail';

    constructor(public error?: any) { }
}

// Send Consignment Status
export class SendConsignmentStatusAction {
    static readonly type = '[Driver Tracking] Send Consignment Status';

    constructor(public command: SendConsignmentStatusCommand) { }
}

export class SendConsignmentStatusSuccessAction {
    static readonly type = '[Driver Tracking] Send Consignment Status Success';

    constructor(public payload: { response: SendConsignmentStatusResponse }) { }
}

export class SendConsignmentStatusFailAction {
    static readonly type = '[Driver Tracking] Send Consignment Status Fail';

    constructor(public error?: any) { }
}

// Report Parcel Count Discrepancy
export class ReportParcelCountDiscrepancyAction {
    static readonly type = '[Driver Tracking] Report Parcel Count Discrepancy';

    constructor(public command: ReportParcelCountDiscrepancyCommand) { }
}

export class ReportParcelCountDiscrepancySuccessAction {
    static readonly type = '[Driver Tracking] Report Parcel Count Discrepancy Success';

    constructor(public payload: { response: ReportParcelCountDiscrepancyResponse }) { }
}

export class ReportParcelCountDiscrepancyFailAction {
    static readonly type = '[Driver Tracking] Report Parcel Count Discrepancy Fail';

    constructor(public error?: any) { }
}
